// extracted by mini-css-extract-plugin
module.exports = {"dispensers":"styles_dispensers__3Gw5-","btn":"styles_btn__2h7p3"};